export default __webpack_public_path__ + "static/media/conveniencemobile.9130174f.png";